import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "./../context/AppContext";
import "bootstrap/dist/css/bootstrap.min.css";
import "jquery/dist/jquery.min.js";
//Datatable Modules
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from "jquery";
import { Link, useLocation } from "react-router-dom";
import Form from "react-bootstrap/Form";

import ic_delete from "../assets/images/ic_delete.svg";
import ic_edit from "../assets/images/ic_edit.svg";
import ic_eyes from "../assets/images/ic_eyes.svg";
import Modal from "react-bootstrap/Modal";
import ApiConfig from "../api/ApiConfig";
import { simpleGetCall, simplePostCall } from "../api/ApiServices";
import { Table } from "react-bootstrap";
import Loading from "../sharedComponents/Loaders/Loading";
import moment from "moment/moment";
const StockStatement = () => {
  const { sidebar } = useContext(AppContext);
  const prePageData = useLocation();
  // console.log("prePageData", prePageData?.state);
  let date = new Date();
  const [isLoading, setIsLoading] = useState(false);
  const [stockList, setStockList] = useState([]);
  const [vendingMachineList, setVendingMachineList] = useState([]);
  const [selectedMachineId, setSelectedMachineId] = useState(
    JSON.stringify(prePageData?.state?.id)
  );

  console.log("selectedMachineId", selectedMachineId);
  const [selectedDate, setSelectedDate] = useState(date);
  const getStocksList = () => {
    setIsLoading(true);
    let body = JSON.stringify({
      startdate: selectedDate,
      enddate: "",
      machineid: selectedMachineId,
    });
    simplePostCall(ApiConfig.STOCK_TRANSACTION_LIST, body)
      .then((res) => {
        // console.log(res);
        let data = res;
        if (data) {
          setStockList(data.objlist);
          setIsLoading(false);
        }
      })

      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };

  // GET_ALL_VENDING_MACHINE
  const getAllVendingMachineList = () => {
    setIsLoading(true);
    simpleGetCall(ApiConfig.GET_ALL_VENDING_MACHINE)
      .then((res) => {
        if (res.result === true) {
          setVendingMachineList(res.vendingMachineList);
          // setSelectedMachineId(res?.vendingMachineList[0]?.machine_Id);
          setIsLoading(false);
        } else {
          console.log("error response", res);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.log("catch error response,", error);
        setIsLoading(false);
      });
  };
  useEffect(() => {
    if (selectedMachineId) {
      getStocksList();
    }

    return () => {};
  }, [selectedMachineId, selectedDate]);
  useEffect(() => {
    getAllVendingMachineList();

    return () => {};
  }, []);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [deleteShow, setDeleteShow] = useState(false);
  const handleDeleteClose = () => setDeleteShow(false);
  const handleDeleteShow = () => setDeleteShow(true);

  const [validated, setValidated] = useState(false);
  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }

    setValidated(true);
  };
  return (
    <main
      id="cx-main"
      className={sidebar ? "admin-main" : "cx-active admin-main"}
    >
      <div className="heading-btn-main">
        <div className="heading-common">
          <label htmlFor="">STOCK STATEMENT</label>
        </div>
        {/* <div className="add-btn">
          <button onClick={handleShow}>
            Add Vending Machine
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              preserveAspectRatio="xMidYMid meet"
              viewBox="0 0 24 24"
            >
              <path fill="white" d="M11 19v-6H5v-2h6V5h2v6h6v2h-6v6Z" />
            </svg>
          </button>
        </div> */}
      </div>

      <Modal
        show={deleteShow}
        onHide={handleDeleteClose}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="delete-msg text-center">
            <label htmlFor="">Do you want to delete?</label>
          </div>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <div className="buttons-modal    ">
            <button
              className="me-2 "
              type="submit"
              style={{ backgroundColor: "red" }}
            >
              Delete
            </button>
            <Link to="#" className="" onClick={handleDeleteClose}>
              Cancel
            </Link>
          </div>
        </Modal.Footer>
      </Modal>

      <div className="table-wrapper">
        <div className="select-wrapper row">
          <Form.Group className="mb-4 col-md-4">
            <Form.Label>Select Vending Machine</Form.Label>
            <Form.Select
              value={selectedMachineId}
              onChange={(e) => {
                setSelectedMachineId(e.target.value);
              }}
            >
              <option  value="1">
              Select Vending Machine
                  </option>
              {vendingMachineList?.map((machine, index) => {
                return (
                  <option key={"machine" + index} value={machine?.id}>
                    {machine?.name}
                  </option>
                );
              })}
               
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-4 col-md-4">
            <Form.Label>From Date</Form.Label>
            <Form.Control
              type="date"
              value={moment(selectedDate).format("YYYY-MM-DD")}
              onChange={(e) => {
                setSelectedDate(e.target.value);
              }}
              max={moment(new Date()).format("YYYY-MM-DD")}
            />
          </Form.Group>
        </div>
        {isLoading ? (
          <Loading />
        ) : (
          <Table striped hover id="" class="table display">
            <thead>
              <tr>
                <th>Sr No.</th>
                <th>Date & Time</th>
                <th>Slot No.</th>
                <th>Product Name</th>
                <th>Available Quantity</th>
                <th>Sales Quantity</th>
              </tr>
            </thead>
            {stockList?.length > 0 ? (
              <tbody>
                {stockList?.map((stock, index) => {
                  return (
                    <tr key={"stock" + index}>
                      <td>{index + 1}</td>
                      <td>{moment(stock?.inventoryDate).format("LLL")}</td>
                      <td>{stock?.slotNo}</td>
                      <td>{stock?.productName}</td>
                      <td>{stock?.quantity}</td>
                      <td>{stock?.salesqty}</td>
                    </tr>
                  );
                })}
              </tbody>
            ) : (
              <React.Fragment>
                <p className="text-danger m-2">
                  No stock found on this Machine
                </p>
              </React.Fragment>
            )}
          </Table>
        )}
      </div>
    </main>
  );
};

export default StockStatement;
